// src/theme/theme.js
import { createTheme } from '@mui/material/styles';

// Dark blue palette for admin dashboard
const primaryBlue = '#0A2540'; // deep navy
const secondaryBlue = '#1E3A5F'; // lighter shade

const theme = createTheme({
  direction: 'rtl',
  palette: {
    mode: 'dark',
    primary: {
      main: primaryBlue,
    },
    secondary: {
      main: secondaryBlue,
    },
    background: {
      default: '#111827', // very dark gray for better contrast
      paper: '#1F2937',
    },
    text: {
      primary: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: "'Cairo', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    button: { textTransform: 'none' },
  },
});

export default theme;
